(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sasha-artwork-protection"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.SashaArtworkProtectionInitialized) return;

  window.SashaArtworkProtectionInitialized = true;

  const isProtectedArtwork = (target) => {
    return target instanceof Element && target.closest('[data-artwork-protected]');
  };

  document.addEventListener('contextmenu', (event) => {
    if (isProtectedArtwork(event.target)) event.preventDefault();
  });

  document.addEventListener('dragstart', (event) => {
    if (isProtectedArtwork(event.target)) event.preventDefault();
  });

  document.addEventListener('selectstart', (event) => {
    if (isProtectedArtwork(event.target)) event.preventDefault();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sasha-selection-sync"] && !Shopify.designMode) return;
  try {
    class SashaSelectionSync extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    const root = this.closest('[data-sasha-selection]');
    if (!root) return;
    const inputs = [...root.querySelectorAll('[data-product-option], [data-portrait-option]')];
    const records = [...root.querySelectorAll('[data-variant-record], [data-portrait-variant-record]')];
    const key = `sasha-variant:${root.dataset.productId}`;
    const language = root.dataset.locale || document.documentElement.lang || 'en';
    const locale = root.dataset.country && !language.includes('-') ? `${language}-${root.dataset.country}` : language;
    const money = new Intl.NumberFormat(locale, { style: 'currency', currency: root.dataset.currency || 'EUR' });
    const refresh = () => {
      root.querySelector('sasha-size-picker')?.sync?.();
      const size = inputs.find((input) => input.checked && (input.dataset.productOption || input.dataset.portraitOption) === 'size')?.value;
      const base = records.find((record) => record.dataset.sizeValue === size && record.dataset.isFramed !== 'true');
      const framed = records.find((record) => record.dataset.sizeValue === size && record.dataset.isFramed === 'true');
      const surcharge = root.querySelector('[data-frame-surcharge]');
      if (surcharge) {
        surcharge.textContent = base && framed ? ` · +${money.format((Number(framed.dataset.variantPriceMinor) - Number(base.dataset.variantPriceMinor)) / 100)}` : '';
      }
    };
    const applyRecord = (record) => {
      if (!record || record.dataset.available !== 'true') return;
      inputs.forEach((input) => {
        const option = input.dataset.productOption || input.dataset.portraitOption;
        input.checked = input.value === (option === 'size' ? record.dataset.sizeValue : record.dataset.frameValue);
      });
      inputs.find((input) => input.checked)?.dispatchEvent(new Event('change', { bubbles: true }));
    };
    root.addEventListener('sasha:variant', refresh, { signal });
    root.addEventListener('change', (event) => {
      if (!inputs.includes(event.target)) return;
      refresh();
      const id = root.querySelector('input[name="id"]')?.value;
      if (!id) return;
      try { sessionStorage.setItem(key, id); } catch (_) {}
      const url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      history.replaceState(history.state, '', url);
    }, { signal });
    window.addEventListener('popstate', () => {
      const id = new URLSearchParams(window.location.search).get('variant');
      applyRecord(records.find((record) => record.dataset.variantId === id));
      refresh();
    }, { signal });
    this.frame = requestAnimationFrame(() => {
      if (!new URLSearchParams(window.location.search).has('variant')) {
        let id;
        try { id = sessionStorage.getItem(key); } catch (_) {}
        applyRecord(records.find((record) => record.dataset.variantId === id));
      }
      refresh();
    });
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    cancelAnimationFrame(this.frame);
  }
}
if (!customElements.get('sasha-selection-sync')) customElements.define('sasha-selection-sync', SashaSelectionSync);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sasha-size-picker"] && !Shopify.designMode) return;
  try {
    class SashaSizePicker extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.trigger = this.querySelector('[data-size-trigger]');
    this.panel = this.querySelector('[data-size-panel]');
    this.dialog = document.createElement('dialog');
    this.dialog.className = 'sasha-size-picker__dialog';
    this.dialog.id = this.trigger.getAttribute('aria-controls');
    this.dialog.setAttribute('aria-labelledby', `${this.dialog.id.replace('-dialog', '')}-title`);
    this.dialog.setAttribute('aria-describedby', `${this.dialog.id.replace('-dialog', '')}-hint`);
    this.dialog.append(this.panel);
    this.append(this.dialog);
    this.trigger.hidden = false;
    this.querySelector('[data-size-heading]').hidden = false;
    this.trigger.addEventListener('click', () => this.open(), { signal });
    this.querySelector('[data-size-close]').addEventListener('click', () => this.close(), { signal });
    this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close(); }, { signal });
    this.dialog.addEventListener('animationend', (event) => {
      if (event.target === this.dialog && event.animationName === 'sasha-picker-exit') this.finishClose();
    }, { signal });
    this.dialog.addEventListener('click', (event) => {
      const row = event.target.closest('.sasha-size-picker__row');
      if (row?.control && !row.control.disabled) {
        cancelAnimationFrame(this.closeFrame);
        this.closeFrame = requestAnimationFrame(() => this.close());
      }
      if (event.target === this.dialog || (event.detail > 0 && event.target.matches('.sasha-size-picker__radio'))) this.close();
    }, { signal });
    this.dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' || ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.sasha-size-picker__radio'))) { event.preventDefault(); this.close(); }
    }, { signal });
    document.addEventListener('pointerdown', (event) => {
      if (this.dialog.open && !this.dialog.matches(':modal') && !this.contains(event.target)) this.close(false);
    }, { signal });
    this.addEventListener('change', (event) => {
      if (!event.target.matches('.sasha-size-picker__radio')) return;
      this.sync();
    }, { signal });
    this.media = window.matchMedia('(max-width: 749px)');
    this.media.addEventListener('change', () => this.close(true, true), { signal });
    this.sync();
  }
  sync() {
    const input = this.querySelector('.sasha-size-picker__radio:checked');
    if (!input) return;
    this.querySelector('[data-size-value]').textContent = input.dataset.sizeLabel;
    this.querySelector('[data-size-price]').textContent = input.dataset.basePrice;
  }
  open(opener = this.trigger) {
    if (this.dialog.open) return;
    this.opener = opener;
    this.modalState = this.media.matches;
    if (this.media.matches) {
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
    } else {
      this.dialog.show();
    }
    this.trigger.setAttribute('aria-expanded', 'true');
    this.querySelector('.sasha-size-picker__radio:checked:not(:disabled)')?.focus({ preventScroll: true });
  }
  close(restoreFocus = true, immediate = false) {
    cancelAnimationFrame(this.closeFrame);
    if (!this.dialog.open) return;
    this.restoreFocus = restoreFocus;
    if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.finishClose();
      return;
    }
    if (this.dialog.classList.contains('is-closing')) return;
    this.dialog.classList.add('is-closing');
    this.closeTimer = setTimeout(() => this.finishClose(), 240);
  }
  finishClose() {
    clearTimeout(this.closeTimer);
    if (!this.dialog.open) return;
    this.dialog.close();
    this.dialog.classList.remove('is-closing');
    if (this.modalState) document.documentElement.style.overflow = this.previousOverflow || '';
    this.trigger.setAttribute('aria-expanded', 'false');
    if (this.restoreFocus) this.opener?.focus({ preventScroll: true });
  }
  disconnectedCallback() {
    this.close(false, true);
    this.controller?.abort();
    this.controller = null;
    this.append(this.panel);
    this.dialog.remove();
  }
}
if (!customElements.get('sasha-size-picker')) customElements.define('sasha-size-picker', SashaSizePicker);
  } catch(e) { console.error(e); }
})();

})();
